<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';

  const ORIGENS = {
    ambos: { texto: 'Geral + individual', classe: 'cri-tag-ok', dica: 'O crédito veio no extrato geral e no extrato da conta; ficou uma linha só.' },
    geral: { texto: 'Só no geral', classe: 'cri-tag-alerta', dica: 'Veio só no extrato geral (todas as contas). O extrato da conta traria o nome de quem pagou.' },
    conta: { texto: 'Extrato da conta', classe: 'cri-tag-neutra', dica: 'Veio só no extrato da própria conta.' },
  };

  export default {
    components: { DatePicker },
    data() {
      return {
        carregando: false,
        dataIni: moment().subtract(3, 'days').toDate(),
        dataFim: moment().toDate(),
        origem: 'baixar',
        situacao: '',
        busca: '',
        expandidos: {},
        resumo: { qtde: 0, qtdeContas: 0, valor: 0, ambos: 0, soGeral: 0, semIdentificacao: 0, pendentes: 0, dias: [] },
      }
    },
    computed: {
      dias() {
        const texto = (this.busca || '').trim().toLowerCase();
        if (!texto) return this.resumo.dias || [];

        const dias = [];
        (this.resumo.dias || []).forEach(dia => {
          const contas = [];
          (dia.contas || []).forEach(conta => {
            const linhas = (conta.linhas || []).filter(l => this.casaBusca(l, conta, texto));
            if (linhas.length === 0) return;
            contas.push(Object.assign({}, conta, {
              linhas,
              qtde: linhas.length,
              valor: linhas.reduce((s, l) => s + (l.valor || 0), 0),
              soGeral: linhas.filter(l => l.origem === 'geral').length,
              baixar: linhas.filter(l => l.baixar).length,
              semIdentificacao: linhas.filter(l => !l.identificado).length,
              pendentes: linhas.filter(l => !l.conciliado).length,
            }));
          });
          if (contas.length === 0) return;
          dias.push(Object.assign({}, dia, {
            contas,
            qtdeContas: contas.length,
            qtde: contas.reduce((s, c) => s + c.qtde, 0),
            valor: contas.reduce((s, c) => s + c.valor, 0),
          }));
        });
        return dias;
      },
      linhasVisiveis() {
        const linhas = [];
        this.dias.forEach(d => d.contas.forEach(c => c.linhas.forEach(l => linhas.push(l))));
        return linhas;
      },
      totalLinhas() { return this.linhasVisiveis.length; },
      totalValor() { return this.linhasVisiveis.reduce((s, l) => s + (l.valor || 0), 0); },
      totalContas() {
        const chaves = {};
        this.dias.forEach(d => d.contas.forEach(c => { chaves[c.idConta] = true; }));
        return Object.keys(chaves).length;
      },
      totalAmbos() { return this.linhasVisiveis.filter(l => l.origem === 'ambos').length; },
      linhasBaixar() { return this.linhasVisiveis.filter(l => l.baixar); },
      contasBaixar() {
        const chaves = {};
        this.dias.forEach(d => d.contas.forEach(c => { if (c.baixar > 0) chaves[c.idConta] = true; }));
        return Object.keys(chaves).length;
      },
      linhasSemIdentificacao() { return this.linhasVisiveis.filter(l => !l.identificado); },
      temFiltro() { return this.origem !== 'baixar' || !!this.situacao || !!(this.busca || '').trim(); },
      periodoTexto() {
        if (!this.dataIni || !this.dataFim) return '';
        return moment(this.dataIni).format('DD/MM') + ' – ' + moment(this.dataFim).format('DD/MM/YYYY');
      },
      todosExpandidos() {
        return this.dias.length > 0 && this.dias.every(d => d.contas.every(c => this.expandido(d, c)));
      },
    },
    mounted() {
      this.carregar();
    },
    methods: {
      casaBusca(linha, conta, texto) {
        const digitos = texto.replace(/\D/g, '');
        const campos = [linha.historico, linha.documento, linha.nomeContraparte, conta.nomeConta, conta.numeroConta];
        if (campos.some(c => (c || '').toLowerCase().indexOf(texto) >= 0)) return true;
        return digitos.length >= 3 && (linha.cpfCnpj || '').indexOf(digitos) >= 0;
      },
      rotuloOrigem(l) { return ORIGENS[l.origem] || ORIGENS.conta; },
      dicaOrigem(l) {
        const arquivos = [l.arquivo, l.arquivoPar].filter(a => !!a).join('\n');
        return this.rotuloOrigem(l).dica + (arquivos ? '\n\n' + arquivos : '');
      },
      situacaoLinha(l) {
        if (l.conciliado) return { classe: 'cri-tag-ok', texto: 'Conciliado' };
        if (l.statusConciliacao === 2) return { classe: 'cri-tag-info', texto: 'Sugestão da IA' };
        return { classe: 'cri-tag-neutra', texto: 'Pendente' };
      },
      documentoFormatado(doc) {
        const d = (doc || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
        if (d.length === 14) return d.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
        if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        return doc || '';
      },
      formatar(v) { return (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
      diaPorExtenso(dia) {
        const data = moment(dia.data, 'DD/MM/YYYY');
        return data.isValid() ? data.format('ddd, DD/MM/YYYY') : dia.data;
      },
      chaveConta(dia, conta) { return dia.dataMovimento + '-' + conta.idConta; },
      expandido(dia, conta) { return !!this.expandidos[this.chaveConta(dia, conta)]; },
      alternar(dia, conta) {
        const chave = this.chaveConta(dia, conta);
        this.$set(this.expandidos, chave, !this.expandidos[chave]);
      },
      alternarTodos() {
        const abrir = !this.todosExpandidos;
        const novos = {};
        if (abrir) this.dias.forEach(d => d.contas.forEach(c => { novos[this.chaveConta(d, c)] = true; }));
        this.expandidos = novos;
      },
      carregar() {
        this.carregando = true;
        const filtros = {
          dataIni: this.dataIni ? moment(this.dataIni).format('YYYY-MM-DD') : '',
          dataFim: this.dataFim ? moment(this.dataFim).format('YYYY-MM-DD') : '',
          origem: this.origem,
          situacao: this.situacao,
        };
        return conciliacaoProjetoServico.creditosIdentificados(filtros)
          .then(dados => { this.resumo = dados; this.carregando = false; this.expandidos = {}; })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar os créditos do período.'); });
      },
      filtrarOrigem(origem) {
        if (this.origem === origem) return;
        this.origem = origem;
        this.carregar();
      },
      filtrarSituacao(situacao) {
        if (this.situacao === situacao) return;
        this.situacao = situacao;
        this.carregar();
      },
      limparFiltros() {
        this.origem = 'baixar';
        this.situacao = '';
        this.busca = '';
        this.carregar();
      },
      voltar() { this.$emit('fechar'); },
    },
  }
</script>

<template>
  <div class="cri cri-ov">

    <div class="cri-box">

      <div class="cri-head">
        <div>
          <h2 class="no-margins cri-titulo">
            Créditos identificados
            <span class="cri-periodo mono" v-if="periodoTexto">{{ periodoTexto }}</span>
          </h2>
          <div class="cri-sub">
            Quais contas receberam crédito, de quem e por qual extrato ele chegou. Em <strong class="txt-alerta">extratos a baixar</strong>
            ficam só as contas cujo extrato individual traz quem pagou (recebimentos diversos, Pix, TED e transferência recebidos)
            e que ainda não foi enviado. Resgates, cartão, cobrança e devoluções não entram: o individual não acrescenta nada.
          </div>
        </div>
      </div>

      <div class="cri-kpis">
        <div class="cri-kpi">
          <div>
            <div class="cri-kpi-lbl">Créditos</div>
            <div><span class="cri-kpi-num mono">{{ totalLinhas }}</span> <span class="cri-kpi-qlf">em {{ totalContas }} conta(s)</span></div>
          </div>
        </div>
        <div class="cri-kpi cri-kpi-valor">
          <div>
            <div class="cri-kpi-lbl">Valor recebido</div>
            <div><span class="cri-kpi-num mono">R$ {{ formatar(totalValor) }}</span></div>
          </div>
        </div>
        <div class="cri-kpi">
          <div>
            <div class="cri-kpi-lbl">Geral + individual</div>
            <div><span class="cri-kpi-num mono">{{ totalAmbos }}</span> <span class="cri-kpi-qlf">vieram nos dois</span></div>
          </div>
        </div>
        <div class="cri-kpi" :class="{ 'cri-kpi-acao': contasBaixar > 0 }">
          <div>
            <div class="cri-kpi-lbl">Extratos a baixar</div>
            <div><span class="cri-kpi-num mono">{{ contasBaixar }}</span> <span class="cri-kpi-qlf">conta(s) · {{ linhasBaixar.length }} crédito(s)</span></div>
          </div>
          <button v-if="contasBaixar > 0 && origem !== 'baixar'" type="button" class="btn cri-btn-acao" @click="filtrarOrigem('baixar')">Ver</button>
        </div>
        <div class="cri-kpi" :class="{ 'cri-kpi-acao': linhasSemIdentificacao.length > 0 }">
          <div>
            <div class="cri-kpi-lbl">Sem identificação</div>
            <div><span class="cri-kpi-num mono">{{ linhasSemIdentificacao.length }}</span> <span class="cri-kpi-qlf">sem nome nem CPF/CNPJ</span></div>
          </div>
          <button v-if="linhasSemIdentificacao.length > 0 && situacao !== 'sem-identificacao'" type="button" class="btn cri-btn-acao" @click="filtrarSituacao('sem-identificacao')">Ver</button>
        </div>
      </div>

      <div class="cri-filtros">
        <div class="cri-f">
          <label class="cri-f-lbl">Período</label>
          <div class="cri-f-periodo">
            <date-picker v-model="dataIni" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                         :editable="false" :shortcuts="false" :clearable="false" style="width:118px" @change="carregar"></date-picker>
            <span class="cri-ate">até</span>
            <date-picker v-model="dataFim" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                         :editable="false" :shortcuts="false" :clearable="false" style="width:118px" @change="carregar"></date-picker>
          </div>
        </div>
        <div class="cri-f">
          <label class="cri-f-lbl">Veio de</label>
          <select class="form-control" style="width:190px" v-model="origem" @change="carregar">
            <option value="">Qualquer extrato</option>
            <option value="baixar">Extrato a baixar</option>
            <option value="ambos">Geral + individual</option>
            <option value="geral">Só no geral</option>
            <option value="conta">Só no extrato da conta</option>
          </select>
        </div>
        <div class="cri-f">
          <label class="cri-f-lbl">Situação</label>
          <select class="form-control" style="width:180px" v-model="situacao" @change="carregar">
            <option value="">Todas</option>
            <option value="pendente">Pendentes</option>
            <option value="conciliado">Conciliados</option>
            <option value="sem-identificacao">Sem identificação</option>
          </select>
        </div>
        <div class="cri-f cri-f-busca">
          <label class="cri-f-lbl">Buscar</label>
          <div class="cri-busca-wrap">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control" v-model="busca" placeholder="Nome, CPF/CNPJ, histórico ou conta">
          </div>
        </div>
        <div class="cri-f">
          <label class="cri-f-lbl">&nbsp;</label>
          <button type="button" class="btn" :class="temFiltro ? 'btn-warning' : 'btn-white'" :disabled="!temFiltro" @click="limparFiltros">
            <i class="fa fa-eraser"></i> Limpar filtros
          </button>
        </div>
      </div>

      <div v-if="carregando" class="text-center cri-vazio"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

      <div v-else-if="dias.length === 0" class="cri-vazio">
        <div class="cri-vazio-t">Nenhum crédito corresponde aos filtros</div>
        <div class="cri-vazio-s">Ajuste o período, a origem, a situação ou a busca.</div>
      </div>

      <div v-else class="cri-lista">
        <div class="cri-lista-acoes">
          <button type="button" class="cri-link" @click="alternarTodos">
            <i class="fa" :class="todosExpandidos ? 'fa-compress' : 'fa-expand'"></i>
            {{ todosExpandidos ? 'Recolher todas as contas' : 'Abrir todas as contas' }}
          </button>
        </div>

        <div v-for="dia in dias" :key="dia.dataMovimento">
          <div class="cri-dia">
            <div><i class="fa fa-calendar"></i> {{ diaPorExtenso(dia) }}</div>
            <div class="cri-dia-res mono">
              {{ dia.qtdeContas }} conta(s) · {{ dia.qtde }} crédito(s)
              <strong>R$ {{ formatar(dia.valor) }}</strong>
            </div>
          </div>

          <div v-for="conta in dia.contas" :key="chaveConta(dia, conta)">
            <div class="cri-conta" :class="{ 'cri-conta-alerta': conta.baixar > 0 }" @click="alternar(dia, conta)">
              <div class="cri-c-chevron"><i class="fa" :class="expandido(dia, conta) ? 'fa-caret-down' : 'fa-caret-right'"></i></div>
              <div class="cri-c-conta">
                <span class="cri-c-nome mono">{{ conta.numeroConta || conta.nomeConta }}</span>
                <span class="cri-c-desc">{{ conta.nomeConta }}</span>
              </div>
              <div class="cri-c-qtde mono">{{ conta.qtde }} crédito{{ conta.qtde > 1 ? 's' : '' }}</div>
              <div class="cri-c-valor mono">R$ {{ formatar(conta.valor) }}</div>
              <div class="cri-c-chips">
                <span v-if="conta.baixar > 0" class="cri-chip cri-chip-alerta"><i class="fa fa-download"></i> baixar extrato da conta · {{ conta.baixar }} crédito{{ conta.baixar > 1 ? 's' : '' }}</span>
                <span v-if="conta.semIdentificacao > 0" class="cri-chip cri-chip-info"><i class="fa fa-circle"></i> {{ conta.semIdentificacao }} sem identificação</span>
                <span v-if="conta.pendentes > 0" class="cri-chip cri-chip-neutro"><i class="fa fa-circle"></i> {{ conta.pendentes }} pendente{{ conta.pendentes > 1 ? 's' : '' }}</span>
                <span v-if="!conta.baixar && !conta.semIdentificacao && !conta.pendentes" class="cri-chip cri-chip-ok"><i class="fa fa-circle"></i> tudo identificado e conciliado</span>
              </div>
            </div>

            <div v-if="expandido(dia, conta)" class="cri-detalhe">
              <div class="cri-d-head">
                <div>Quem pagou</div>
                <div>Histórico</div>
                <div class="text-right">Valor</div>
                <div>Veio de</div>
                <div>Situação</div>
              </div>
              <div v-for="l in conta.linhas" :key="l.idExtrato" class="cri-d-linha">
                <div class="cri-d-pagador">
                  <template v-if="l.identificado">
                    <div class="cri-d-nome">{{ l.nomeContraparte || '(nome não veio no extrato)' }}</div>
                    <div v-if="l.cpfCnpj" class="cri-d-doc mono">{{ documentoFormatado(l.cpfCnpj) }}</div>
                  </template>
                  <span v-else class="cri-d-sem">Não identificado</span>
                </div>
                <div class="cri-d-hist" :title="l.historico">
                  {{ l.historico }}
                  <div v-if="l.documento" class="cri-d-doc mono">doc. {{ l.documento }}</div>
                </div>
                <div class="text-right mono txt-ok">R$ {{ formatar(l.valor) }}</div>
                <div><span class="cri-tag" :class="rotuloOrigem(l).classe" :title="dicaOrigem(l)">{{ rotuloOrigem(l).texto }}</span></div>
                <div><span class="cri-tag" :class="situacaoLinha(l).classe">{{ situacaoLinha(l).texto }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cri-rodape">
        <div class="cri-rodape-txt">
          Passe o mouse na origem para ver os arquivos de onde o crédito veio.
        </div>
        <div class="cri-rodape-btns">
          <button type="button" class="cri-btn cri-sair" @click="voltar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
  .cri .mono { font-family: Menlo, Consolas, monospace; font-variant-numeric: tabular-nums; }
  .txt-alerta { color: #a13c3c; }
  .txt-ok { color: #0a6d4d; }

  .cri-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .cri-box { width: 1320px; max-width: 96vw; height: 92vh; display: flex; flex-direction: column;
             background: #fff; border: 1px solid #d3d8de; border-radius: 10px; overflow: hidden; padding: 0;
             box-shadow: 0 16px 48px rgba(16,24,40,.35); }
  .cri-head, .cri-kpis, .cri-filtros, .cri-rodape { flex: 0 0 auto; }

  .cri-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding: 16px 18px 14px; }
  .cri-titulo { font-size: 21px; font-weight: 600; letter-spacing: -.01em; }
  .cri-periodo { font-size: 11px; padding: 2px 6px; border-radius: 4px; background: #eef1f4; color: #5b6570; vertical-align: middle; }
  .cri-sub { font-size: 12.5px; color: #6b747e; max-width: 820px; margin-top: 5px; }

  .cri-kpis { display: grid; grid-template-columns: repeat(5, 1fr); gap: 1px; background: #e6e9ed; border-top: 1px solid #dfe3e8; border-bottom: 1px solid #dfe3e8; }
  .cri-kpi { background: #fff; padding: 12px 18px; display: flex; justify-content: space-between; align-items: center; gap: 10px; }
  .cri-kpi-lbl { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; margin-bottom: 3px; }
  .cri-kpi-num { font-size: 20px; font-weight: 600; color: #1c2024; }
  .cri-kpi-qlf { font-size: 11.5px; color: #8a939c; margin-left: 5px; }
  .cri-kpi-valor { background: #f4faf7; border-left: 2px solid #0a6d4d; }
  .cri-kpi-valor .cri-kpi-lbl, .cri-kpi-valor .cri-kpi-num { color: #0a6d4d; }
  .cri-kpi-acao { background: #fdf7f7; border-left: 2px solid #c98080; }
  .cri-kpi-acao .cri-kpi-lbl, .cri-kpi-acao .cri-kpi-num, .cri-kpi-acao .cri-kpi-qlf { color: #a13c3c; }
  .cri-btn-acao { height: 30px; padding: 0 12px; font-size: 12.5px; font-weight: 600; background: #fff; border: 1px solid #c98080; color: #a13c3c; white-space: nowrap; }
  .cri-btn-acao:hover { background: #fbeeee; color: #a13c3c; }

  .cri-filtros { display: flex; align-items: flex-end; gap: 14px; padding: 13px 18px; background: #f7f9fa; border-bottom: 1px solid #dfe3e8; flex-wrap: wrap; }
  .cri-f { display: flex; flex-direction: column; gap: 5px; }
  .cri-f-busca { flex: 1; min-width: 220px; }
  .cri-f-lbl { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #7b848e; margin: 0; }
  .cri-f-periodo { display: flex; align-items: center; gap: 8px; }
  .cri-ate { font-size: 12.5px; color: #8a939c; }
  .cri-busca-wrap { position: relative; }
  .cri-busca-wrap .fa-search { position: absolute; left: 10px; top: 11px; font-size: 13px; color: #8a939c; }
  .cri-busca-wrap .form-control { padding-left: 30px; }

  .cri-lista { flex: 1 1 auto; min-height: 0; overflow: auto; background: #fff; }
  .cri-lista-acoes { display: flex; justify-content: flex-end; padding: 6px 18px; border-bottom: 1px solid #eef1f4; }
  .cri-link { border: none; background: transparent; padding: 0; color: #2b6cb0; font-size: 12px; font-weight: 600; }
  .cri-link:hover { text-decoration: underline; }
  .cri-link .fa { margin-right: 4px; }

  .cri-dia { position: sticky; top: 0; z-index: 3; display: flex; justify-content: space-between; align-items: center; padding: 9px 18px; background: #eef1f4; border-bottom: 1px solid #dfe3e8; font-size: 13.5px; font-weight: 600; }
  .cri-dia-res { font-size: 12px; font-weight: 400; color: #6b747e; }
  .cri-dia-res strong { font-size: 13px; color: #1c2024; margin-left: 8px; }

  .cri-conta { display: grid; grid-template-columns: 26px 1.5fr 100px 150px 2fr; gap: 10px; align-items: center; padding: 11px 18px; border-bottom: 1px solid #eef1f4; cursor: pointer; box-shadow: inset 3px 0 0 #e6e9ed; background: #fff; }
  .cri-conta:hover { background: #f4f7f9; }
  .cri-conta-alerta { box-shadow: inset 3px 0 0 #c98080; }
  .cri-c-chevron { color: #6b747e; }
  .cri-c-nome { font-size: 13px; font-weight: 600; color: #1c2024; white-space: nowrap; }
  .cri-c-desc { font-size: 12px; color: #8a939c; margin-left: 6px; }
  .cri-c-qtde { font-size: 12.5px; color: #6b747e; text-align: right; }
  .cri-c-valor { font-size: 13px; font-weight: 600; text-align: right; color: #0a6d4d; }
  .cri-c-chips { display: flex; flex-wrap: wrap; gap: 5px; }

  .cri-chip { display: inline-flex; align-items: center; gap: 6px; border-radius: 99px; padding: 3px 9px 3px 7px; font-size: 11.5px; white-space: nowrap; }
  .cri-chip .fa-circle { font-size: 7px; }
  .cri-chip-ok { background: #f4faf7; border: 1px solid #b7e0cb; color: #0a6d4d; }
  .cri-chip-alerta { background: #fbeeee; border: 1px solid #e4c9c9; color: #a13c3c; }
  .cri-chip-info { background: #fdf8ee; border: 1px solid #ecd9a8; color: #8a5a00; }
  .cri-chip-neutro { background: #f4f7fb; border: 1px solid #c7d5e6; color: #3f5d80; }

  .cri-detalhe { background: #fbfcfd; border-bottom: 1px solid #e6e9ed; padding: 0 18px 10px 44px; }
  .cri-d-head, .cri-d-linha { display: grid; grid-template-columns: 1.3fr 1.6fr 130px 150px 120px; gap: 10px; }
  .cri-d-head { padding: 8px 0 7px; border-bottom: 1px solid #e6e9ed; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .cri-d-linha { padding: 8px 0; border-bottom: 1px solid #f2f4f6; font-size: 12.5px; color: #3b444d; align-items: start; }
  .cri-d-linha:hover { background: #f4f7f9; }
  .cri-d-nome { font-weight: 600; color: #1c2024; }
  .cri-d-doc { font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .cri-d-sem { color: #8a5a00; font-style: italic; }
  .cri-d-hist { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cri-tag { display: inline-block; border-radius: 4px; padding: 2px 7px; font-size: 11.5px; line-height: 1.5; cursor: default; }
  .cri-tag-ok { background: #e3f3ec; color: #0a6d4d; }
  .cri-tag-alerta { background: #fbeeee; color: #a13c3c; }
  .cri-tag-neutra { background: #eef1f4; color: #5b6570; }
  .cri-tag-info { background: #eaf1fb; color: #2b5a92; }

  .cri-vazio { flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 56px 20px; text-align: center; background: #fff; }
  .cri-vazio-t { font-size: 13.5px; font-weight: 600; color: #3b444d; }
  .cri-vazio-s { font-size: 12.5px; color: #8a939c; margin-top: 4px; }

  .cri-rodape {
    display: flex; justify-content: space-between; align-items: center; gap: 16px;
    margin-top: auto; padding: 12px 18px; background: #f7f9fa; border-top: 1px solid #dfe3e8;
    z-index: 5; box-shadow: 0 -2px 6px rgba(16,24,40,.06);
  }
  .cri-rodape-txt { font-size: 12px; color: #8a939c; display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
  .cri-rodape-btns { display: flex; align-items: center; gap: 8px; }

  .cri-btn { display: inline-flex; align-items: center; gap: 7px; background: #fff; border: 1px solid #c6ccd4; border-radius: 5px; padding: 8px 14px; font-size: 12.5px; color: #3b444d; }
  .cri-btn:hover { background: #f4f6f8; }
  .cri-sair { background: #fdf1f1; border-color: #e4d7d7; color: #a13c3c; font-weight: 600; padding: 8px 18px; }
  .cri-sair:hover { background: #fbe7e7; border-color: #d9c2c2; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/CreditosIdentificadosLista.vue